import React from 'react';
import {useMediaQuery} from "@mui/material";
import {getTheme} from "app/components/ThemeProvider/theme";

const useDetailsModal = () => {

    const theme = getTheme('light');

    const smallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const tableRow: any[] = [
        {
            id: '1',
            name: 'ALLAHVERDİYEVA NƏRGİZ ZÖHRAB QIZI',
            iban: 'AZ88NICB00600982750001A40060',
            amount: '500',
            status: 'Aktiv'
        },
        {
            id: '2',
            name: 'ALLAHVERDİYEVA NƏRGİZ ZÖHRAB QIZI',
            iban: 'AZ88NICB00600982750001A40060',
            amount: '550',
            status: 'Blocked'
        },
        {
            id: '3',
            name: 'ALLAHVERDİYEVA NƏRGİZ ZÖHRAB QIZI',
            iban: 'AZ88NICB00600982750001A40060',
            amount: '600',
            status: 'Aktiv'

        },
        {
            id: '4',
            name: 'ALLAHVERDİYEVA NƏRGİZ ZÖHRAB QIZI',
            iban: 'AZ88NICB00600982750001A40060',
            amount: '700',
            status: 'Aktiv'
        },
    ];

    const tableHeader = [
        {
            id: '1',
            name: 'İşçinin A.S.A',
        },
        {
            id: '2',
            name: 'Hesab nömrəsi',
        },
        {
            id: '3',
            name: 'Məbləğ',
        },
    ];

    return {
        smallScreen,
        tableRow,
        tableHeader
    }
};

export default useDetailsModal;